var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 13.3336H5.86675L12.8001 6.40025C13.0728 6.12551 13.2259 5.75406 13.2259 5.36691C13.2259 4.97977 13.0728 4.60832 12.8001 4.33358L11.6667 3.20025C11.392 2.92749 11.0206 2.77441 10.6334 2.77441C10.2463 2.77441 9.87482 2.92749 9.60008 3.20025L2.66675 10.1336V13.3336Z",
    stroke: "#6B7280",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80005 4L12 7.2",
    stroke: "#6B7280",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.33ec46452cb2facdcbf8a02770b567e9.svg";
export { ForwardRef as ReactComponent };